import { Module } from "@/constants";
import { PayrollsService } from "@/services/payrolls";
import { useQuery } from "@tanstack/react-query";

export const usePayrollQuery = (payrollId?: string) => {
  return useQuery({
    queryKey: [Module.Payrolls, payrollId],
    queryFn: () => PayrollsService.get(payrollId ?? ""),
    enabled: payrollId !== undefined,
  });
};
